/* eslint-disable no-irregular-whitespace */
import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

/**
 * https://msdf-bmfont.donmccurdy.com/
 * assets/ja-msdf/custom-msdf.json
 * 1024pxでクリエイト(全角スペースと半角スペースも入ってるので気をつける)
abcdefghijklmnopqrstuvwxyz 　
ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/<>[]{}|¥~^=-?\_!"#$%&'():;0~1234567890
あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもらりるれろやゆよわをんがぎぐげござじずぜぞだじづでどばびぶべぼぱぴぷぺぽゐぁぃぅぇぉゃゅぇょっゑー、。
アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモラリルレロヤユヨワヲンガギグゲゴザジズゼゾダジヅデドバビブベボパピプペポャュョァィゥェォッヵ「」’”＃＄％＆！（）＝〜｜￥＾ー『』＠：；＋＊・？_＜＞、。
 */
export class TextElement extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.TEXT, t.to('半角英数字ひらがなカタカナ', 'text_block'));
  }
  toXmlFromSubBlockCustom(dom: HTMLElement): void {
    dom.appendChild(ShapeSettings.getColorInputValueXML());
  }

  defineBlock(block: BlockType): void {
    // ブロックの属性をセット
    ColorSettings.setObjectColor(block);
    ShapeSettings.setElementShape(block);

    ShapeSettings.setTitleField(block, this.title);

    const fieldText = new Blockly.FieldTextInput('hello world こんにちは');
    block.appendDummyInput().appendField(fieldText, 'text');

    ShapeSettings.setIdField(block);
    block.appendDummyInput().appendField(t.to('位置', 'position') + ':');
    ShapeSettings.setVR3Fields(block, 'position', 0, 1, 0);

    ShapeSettings.getDummyInput(block).appendField(t.to('色', 'color') + ':');
    block.appendValueInput('COLOUR').setCheck('Colour');
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const text = CodeSetting.getFieldValueWithoutEncode(block, 'text');
    const color = CodeSetting.getColorInputValue(block);
    const id = CodeSetting.getFieldValue(block, 'id');

    let attribute = CodeSetting.getSubAttributeCode(block);
    // attribute += `entity.setAttribute("value", "${text}");
    // 	entity.setAttribute("color","${color}");
    // 	entity.setAttribute("id", "${id}");`
    attribute += CodeSetting.getAttributeCode('value', text);
    attribute += CodeSetting.getAttributeCode('color', color);
    attribute += CodeSetting.getAttributeCode('font', './public/custom-msdf/custom-msdf.json');
    attribute += CodeSetting.getAttributeCode('negate', 'false');
    attribute += CodeSetting.getAttributeCode('id', id);
    attribute += CodeSetting.getVR3FieldValues(block, 'position');
    const str = CodeSetting.getElementCode(this.name_for_code, attribute, block.id, '');
    return str;
  }
}
